/** Queries for 'Poddelatnost' */

import { tag } from 'api/rtkTags'
// eslint-disable-next-line
import { initialSubBusinessActivity } from 'constants/initialValues'
import { label } from 'constants/labels'

export const queryGetPagedSubBusinessActivity = (pageNumber, pageSize, options = {}) => {
  return {
    query: {
      name: 'data',
      mode: 'page',
      type: 'podDelatnost',
      data: {
        pageNumber,
        pageSize,
        options
      }
    },
    providesTags: {
      type: tag.subBusinessActivity
    }
  }
}

export const queryGetAllSubBusinessActivity = (options = {}) => {
  return {
    query: {
      name: 'data',
      mode: 'all',
      type: 'podDelatnost',
      data: { options }
    },
    providesTags: {
      type: tag.subBusinessActivity
    }
  }
}
/**
 * @param {initialSubBusinessActivity} data
 */

/**
* @param {initialSubBusinessActivity} data
@param {string} id
*/
export const queryUpdateSubBusinessActivity = (data, id) => {
  return {
    query: {
      name: 'data',
      mode: 'update',
      type: 'podDelatnost',
      data: {
        values: data,
        options: {
          where: {
            id
          }
        }
      }
    },
    invalidatesTags: [tag.subBusinessActivity],
    successMsg: label.successMsgEdit + ' ' + label.msgSubActivity
  }
}

/**
 * @param {initialSubBusinessActivity} data
 */

export const queryAddSubBusinessActivity = data => {
  return {
    query: {
      name: 'data',
      mode: 'new',
      type: 'podDelatnost',
      data: { values: data }
    },
    invalidatesTags: [tag.subBusinessActivity],
    successMsg: label.successMsgCreate + ' ' + label.msgSubActivity
  }
}

/**
@param {string} id
*/
export const queryDeleteSubBusinessActivity = id => {
  return {
    query: {
      name: 'data',
      mode: 'delete',
      type: 'podDelatnost',
      data: {
        options: {
          where: { id }
        }
      }
    },
    invalidatesTags: [tag.subBusinessActivity],
    successMsg: label.successMsgDelete + ' ' + label.msgSubActivity
  }
}
